import { Map, List, fromJS } from 'immutable'

export function organizationView(state = Map(), action) {
  let { organizationView, loading = false, id, type } = action

  if (type === 'ORGANIZATION_VIEW_LOADING') return state.setIn(['loading'], loading)

  if (type === 'ORGANIZATION_VIEW_SUCCESS')
    return state
      .setIn(['loading'], false)
      .setIn(['organizationView'], organizationView ? fromJS(organizationView) : Map())

  if (type === 'ORGANIZATION_VIEW_ERROR') return state.setIn(['loading'], false).setIn(['error'], message)

  if (type === 'ORGANIZATION_VIEW_CLOSE') return state.remove('organizationView')

  return state
}
